import axios from 'axios';
import { SpecialBuildingPartModel } from 'app/edozvola/cases/special-building-part/model/special-building-part.model';

export const fetchSpecialBuildingParts = async (
  idCase: string,
  page: number,
  size: number,
  column: string,
  direction: string,
): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(`api/special-building-part/find-all/${ idCase }?page=${ page }&size=${ size }&column=${ column }&direction=${ direction }`)
        .then(response => resolve(response.data));
    });
  }
};

export const deleteSpecialBuildingPart = async (idSpecialBuildingPart: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/special-building-part/${ idSpecialBuildingPart }`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getSpecialBuildingPart = async (idSpecialBuildingPart: string): Promise<SpecialBuildingPartModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/special-building-part/${ idSpecialBuildingPart }`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveSpecialBuildingPart = async (idCase: string, specialBuildingPart: SpecialBuildingPartModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/special-building-part/${ idCase }`, specialBuildingPart)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const existsSpecialBuildingPart = async (
  idBuilding: number,
  idBuildingPart: number,
  idSpecialBuildingPart: number,
  excludeId: number,
): Promise<boolean> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/special-building-part/exists/${ idBuilding }/${ idBuildingPart }/${ idSpecialBuildingPart }`, {
        params: { excludeId },
      })
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const moveSpecialBuildingPartUp = async (idSpecialBuildingPart: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/special-building-part/move-up/${ idSpecialBuildingPart }`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const moveSpecialBuildingPartDown = async (idSpecialBuildingPart: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/special-building-part/move-down/${ idSpecialBuildingPart }`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchCaseBuildings = async (idCase: string): Promise<any> => {
  return await new Promise(resolve => {
    axios
      .get(`api/construction-building-procedure/${ idCase }/buildings?page=1&size=9999&column=ordering&direction=asc`)
      .then(response => resolve(response.data));
  });
};
